






























































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  getAccountArea,
  getSignatureStatus
} from '@/api/developer/developer-private/private'
import { getWeekAccountList, getRegisterConfig, setRegisterConfig } from '@/api/developer/week'
import { getAccountList, deleteAccount, setAccountUsed, setAccountInvalid } from '@/api/developer/developer-private/company'
import { uploadSignFileUrl } from '@/api/upload'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  deepCopy
} from '@/utils/tool'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

type actStatus = 'open' | 'close'
@Component({
  name: 'DeveloperPirvateAccount'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    accountId: '',
    accountStatus: '',
    createDateStart: '',
    createDateEnd: '',
    id: '',
    page: 1,
    pageCount: 20
  }
  private addParams = { count: 0 }
  // component data
  tableLoading = false
  private uploadSignFileUrl = uploadSignFileUrl
  private tableData: any[] = []
  private statusList: any[] = []
  private areaList: any[] = []
  private selectedData: any[] = []
  private dateArray: string[] = ['', '']
  private totalCount = 0
  private leftCount = 0
  private addFormVisible: boolean = false
  private rules: any = {
    count: [{ required: true, message: '请输入可签名的数量', trigger: 'blur' }]
  }
  private showEdit: boolean = false
  private invalid: any = ['已过期']
  // lifecycle
  async created() {
    this.getTableData()
    this.getSignatureStatus()
    this.getAreaList()
    this.getConfig()
  }
  // methods
  async getTableData() {
    try {
      this.tableLoading = true
      let res: any = await getWeekAccountList(this.params)
      this.tableData = res.data.dataList || []
      this.totalCount = res.data.pageInfo.totalCount
    } catch (error) {
      this.$message.error(error as string)
    } finally {
      this.tableLoading = false
    }
  }
  async getConfig() {
    let res = await getRegisterConfig()
    console.log('config', res)
    this.leftCount = +res.data.count
  }
  async getSignatureStatus() {
    let res: any = await getSignatureStatus()
    this.statusList = res.data.dataList
  }
  async handleExcel() {
    let excelParams = deepCopy(this.params)
    let res: any = await getAccountList(
      Object.assign(excelParams, {
        page: 1,
        pageCount: 3000
      })
    )
    if (res.status.code === 0) {
      setTimeout(() => {
        this['$message'].success('导出成功!')
      }, 200)
    } else {
      this['$message'].error('导出失败!')
      return
    }
    const filterVal: string[] = [
      'id',
      'accountName',
      'accountPwd',
      'status',
      'info',
      'createDate',
      'accountExpire',
      'creatorName'
    ]
    const theader: string[] = [
      'ID',
      '证书',
      '证书密码',
      '状态',
      '信息',
      '到期时间',
      '创建时间',
      '创建人'
    ]
    const list = res.data.dataList || []
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
  }
  async getAreaList() {
    let res: any = await getAccountArea()
    this.areaList = res.data.dataList
  }
  async addAccount() {
    let res: any = await setRegisterConfig(this.addParams)
    if (res.status.code === 0) {
      this['$message'].success('操作成功!')
      this.cancelAddForm()
    } else {
      this['$message'].error('操作失败!')
    }
    await this.getConfig()
    await this.getTableData()
  }
  deleteAccount(id: string) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteAccount(id)
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }
  // 批量开启 && 关闭
  async setAccount(type: actStatus, ids: string) {
    this.tableLoading = true
    let isUsed = type === 'open'
    let res: any = await setAccountUsed(ids)
    if (res.status.code === 0) {
      let t = ids.split(',')
      this.tableData.forEach(item => {
        if (t.includes(item.id.toString())) {
          item.isUse = isUsed
        }
      })
      isUsed
        ? this['$message'].success('账号启用成功!')
        : this['$message'].info('账号关闭成功!')
      this.tableLoading = false
    }
    this.tableLoading = false
  }
  handleDateChange(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
    this.dateArray = ['', '']
    this.getTableData()
  }
  handleAdd() {
    this.addParams.count = this.leftCount
    this.showEdit = true
  }
  handleSelectionChange(list: any[]) {
    this.selectedData = list
  }
  handleSortChange(item: any) {
    const { order } = item
    this.params.page = 1
    this.getTableData()
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleOpenAll(type: actStatus) {
    let canClose = this.selectedData.some(item => item.isUse)
    if (canClose) {
      this['$message'].warning('请选择正确状态的账号进行启用!')
      return
    }
    this.setAccount(type, this.selectIds)
  }
  handleCloseAll(type: actStatus) {
    let canClose = this.selectedData.some(item => !item.isUse)
    if (canClose) {
      this['$message'].warning('请选择正确状态的账号进行关闭!')
      return
    }
    this.setAccount(type, this.selectIds)
  }
  handleRemoveAll() {
    let canDelete = this.selectedData.some(item => item.isUse)
    if (canDelete) {
      this['$message'].warning('请选择正确状态的账号进行删除!')
      return
    }
    this.deleteAccount(this.selectIds)
  }
  willUpload(file: any) {
    let extension = file.name.split('.').pop()
    if (extension !== 'p12') {
      this['$message'].warning('请上传正确的文件格式!')
      return false
    }
  }
  // 设置账号失效
  async setAccountInvalid(item: any) {
    const { id, status } = item
    if (status === '已失效') {
      this['$message'].warning('证书已失效,请勿重复标记!')
      return
    }
    let res: any = await setAccountInvalid(id.toString())
    if (res.status.code === 0) {
      this.$nextTick(() => {
        item.isUse = false
      })
      this['$message'].success('账号设置失效成功!')
    } else {
      this['$message'].error('账号设置失效失败!')
    }
    await this.getTableData()
  }
  setRemove(item: any) {
    let ids = item.id.toString()
    this.deleteAccount(ids)
  }
  // close dialog, clear data
  handleFormClose() {
    this.cancelAddForm()
  }
  cancelAddForm() {
    (this.$refs['addParams'] as Form).resetFields()
    this.addParams = { count: 0 }
    this.addFormVisible = false
  }
  confirmAddForm() {
    let valid = this.addParams.count
    if (valid) {
      this.addAccount()
    } else {
      (this.$refs['addParams'] as Form).validate()
      this['$message'].warning('请填写完成后再提交!')
      return false
    }
  }

  handleEdit() {
    this.addParams.count = this.leftCount
    this.addFormVisible = true
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
